var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.94226 5L7.99976 6.9425L6.05726 5L4.99976 6.0575L6.94226 8L4.99976 9.9425L6.05726 11L7.99976 9.0575L9.94226 11L10.9998 9.9425L9.05726 8L10.9998 6.0575L9.94226 5ZM7.99976 0.5C3.85226 0.5 0.499756 3.8525 0.499756 8C0.499756 12.1475 3.85226 15.5 7.99976 15.5C12.1473 15.5 15.4998 12.1475 15.4998 8C15.4998 3.8525 12.1473 0.5 7.99976 0.5ZM7.99976 14C4.69226 14 1.99976 11.3075 1.99976 8C1.99976 4.6925 4.69226 2 7.99976 2C11.3073 2 13.9998 4.6925 13.9998 8C13.9998 11.3075 11.3073 14 7.99976 14Z",
    fill: "#232323"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelOn);
export default __webpack_public_path__ + "static/media/CancelOn.d88a3db61fc86f0502e91f8615a16707.svg";
export { ForwardRef as ReactComponent };